import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import { Modal } from 'react-bootstrap';

class TrainingCertificationsModalView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      instructors_data: [],
      examiners_data: [],
      modal: false,
      staff_id: false,
      message: '',
      deslocation_type: 1,
      training_id: this.props.training_id,
      loaded: 0,
    };
    //handlers
    this.closeModal = this.closeModal.bind(this);
    this.confirmPresence = this.confirmPresence.bind(this);
    this.forceConfirmPresence = this.forceConfirmPresence.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({
        modal: true,
        training_id: newProps.training_id,
        instructors_data: newProps.instructors_data,
        examiners_data: newProps.examiners_data,
      });
    }
  }


  confirmAbsence (staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a ausência do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        training_id: this.state.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/ausencia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateInstructors(responseJson.data);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmPresence (staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a presença do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        training_id: this.state.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            if(responseJson.data === 'deslocation_alert'){
              self.setState({
                modal_staff: true,
                message: responseJson.message,
                staff_id: staff_id,
                force_change: 0,
              });
              self.props.handleAlert('', '', 'closed');
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');

            }
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  forceConfirmPresence (event) {
    event.preventDefault();
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a presença do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: this.state.staff_id,
        training_id: this.state.training_id,
        deslocation_type: this.state.deslocation_type,
        force_change: 1,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');

          }
          self.setState({
            modal_staff: false,
            staff_id: false,
            force_change: 0,
          });
    }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  closeModal() {
    this.setState({
      modal: false,
    }, this.props.closeModalViewParent());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Visualizar aula/fornecedor</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <h4>Instrutores</h4>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">Nome</th>
                  <th className="text-center">Início</th>
                  <th className="text-center">Fim</th>
                  <th className="text-center">Horas</th>
                  <th className="text-center">Presença</th>
                </tr>
              </thead>
              <tbody id="training-certification-staffs">
                {Object.keys(self.state.instructors_data).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.instructors_data[k].staff_name}</td>
                      <td className="text-center">{self.state.instructors_data[k].date_start_str}</td>
                      <td className="text-center">{self.state.instructors_data[k].date_finish_str}</td>
                      <td className="text-center">{self.state.instructors_data[k].hours}</td>
                      <td className="text-center">
                        {(self.state.instructors_data[k].attendance === 0) ?
                          <button disabled className="btn btn-danger button-inline"><i className="fa fa-fw fa-close"></i></button>
                          :
                          <button className="btn btn-danger button-inline" onClick={() => {self.confirmAbsence(self.state.instructors_data[k].staff_id)}}><i className="fa fa-fw fa-close"></i></button>
                        }
                        {(self.state.instructors_data[k].attendance === 1) ?
                          <button disabled className="btn btn-success button-inline"><i className="fa fa-fw fa-check"></i></button>
                          :
                          <button className="btn btn-success button-inline" onClick={() => {self.confirmPresence(self.state.instructors_data[k].staff_id)}}><i className="fa fa-fw fa-check"></i></button>
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.modal_staff} aria-labelledby="contained-modal-title-md" bsSize={'medium'}>
          <Modal.Header>
            <h4 className="pull-left">{self.state.message}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_staff: false})}}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <p>O colaborador encontra-se de folga e sua residência está em uma cidade diferente do treinamento.</p>
            <p>O colaborador irá por meios próprios?</p>
            <br/>
            <form onSubmit={this.forceConfirmPresence}>
              <div className="row">
                <div className="col-md-12 form-group">
                  <Select
                    className="form-field-name"
                    name="deslocation_type"
                    value={this.state.deslocation_type}
                    searchable={true}
                    placeholder={'Selecionar meio de transporte'}
                    onChange={this.handleSelectChange.bind(this, 'deslocation_type')}
                    options={[
                      {value: 1, label: 'Sim'},
                      {value: 2, label: 'Não'},
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 form-group">
                  <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Enviar resposta</button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_staff: false})}}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingCertificationsModalView;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationsModalView.js